import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { v4 as uuidv4 } from 'uuid';

import { IconChevronLeft as ChevronLeft } from '../../core';

interface Breadcrumb {
  label: string;
  url?: string;
}

interface Props {
  className?: string;
  breadcrumbs?: Array<Breadcrumb>;
}

const DEFAULT_BREADCRUMBS_BREADCRUMBS: NonNullable<Props['breadcrumbs']> = [];

const Breadcrumbs = ({ className = '', breadcrumbs = DEFAULT_BREADCRUMBS_BREADCRUMBS }: Props) => (
  <div className={className}>
    <ChevronLeft />

    {breadcrumbs && (
      <div className="breadcrumbs-list">
        {breadcrumbs.map((breadcrumb, index) =>
          index === breadcrumbs.length - 1 ? (
            <span key={uuidv4()} className="breadcrumbs-item last" aria-current="page">
              {breadcrumb.label}
            </span>
          ) : (
            <Link key={uuidv4()} to={breadcrumb.url || '#'} className="breadcrumbs-item">
              {breadcrumb.label}
            </Link>
          ),
        )}
      </div>
    )}
  </div>
);

const BreadcrumbsStyled = styled(Breadcrumbs)`
  display: flex;
  align-items: center;
  margin-bottom: 0.75rem;
  gap: 0.25rem;

  .breadcrumbs {
    &-list {
      display: flex;
      align-items: center;
      gap: 0.75rem;
    }

    &-item {
      font-size: 0.75rem;
      line-height: 1.166666666666667;
      border: 0 none;
      border-radius: 0.125rem;
      position: relative;
      transition: color 0.3s ease-in-out;
      text-decoration: none;

      &:not(.last) {
        cursor: pointer;
        padding: 0.0625rem 0.25rem;
        color: ${({ theme }) => theme.neutralTextWeak};
        background-color: ${({ theme }) => theme.neutralBackground};

        &::after {
          content: '/';
          position: absolute;
          color: ${({ theme }) => theme.neutralTextDisabled};
          right: -0.5rem;
        }

        &:hover {
          color: ${({ theme }) => theme.neutralText};
        }
      }

      &.last {
        padding: 0;
        color: ${({ theme }) => theme.neutralText};
        background-color: transparent;
        cursor: default;
      }
    }
  }
`;

export default BreadcrumbsStyled;
